export default __webpack_public_path__ + "static/media/es-ib.651f0573.svg";